/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { InviteUserProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "SendInviteCommitteePageService";
const log: any = LoggerModule.getInstance();

export class SendInviteCommitteePageService {
  private static instance: SendInviteCommitteePageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private criteria: any;
  private headers: any;
  private token: string;
  private selectDropDown: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): SendInviteCommitteePageService {
    if (!SendInviteCommitteePageService.instance) {
      SendInviteCommitteePageService.instance =
        new SendInviteCommitteePageService(props);
    }
    return SendInviteCommitteePageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  private setUserDropDown(data: any) {
    this.selectDropDown = data;
  }

  private getUserDropDown() {
    return this.selectDropDown;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    //Settings Props
    compProps = await agent.checkCountInvite();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    compProps = await agent.getPresentationListsProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }

    compProps = await agent.getAllDiscountListsProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }

    compProps = await agent.getUserDropDownListsProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }

    compProps = await agent.getUserListsProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPresentation(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getPresentationListsProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async inviteUser(args: InviteUserProps) {
    log.info(`invite user`, args);
    let compProps: any = null;
    let details: any = args;
    const agent = getAgent();
    compProps = await agent.getInviteUser(details);

    // TODO QUICK FIXS NEED TO BE REMOVED THIS IS TEMPORARY FIX
    // const masq = "fe93dab0-424b-4aa3-9efa-c001b4c04444";
    // details.role = masq;
    // compProps = await agent.getInviteUser(details);
    return compProps;
  }
  public async deleteUser(args: any) {
    const agent = getAgent();
    return agent.getDeleteUser(args);
  }

  public async suspendUser(args: any) {
    log.info(`suspend  user service`, args);
    const agent = getAgent();
    return agent.getSuspendUser(args);
  }

  public async activateUser(args: any) {
    log.info(`activate  user service`, args);
    const agent = getAgent();
    return agent.getActivateUser(args);
  }

  public async reInviteUser(args: any) {
    log.info(`reset user service`, args);
    const agent = getAgent();
    return agent.getReInviteUser(args);
  }
  public async sendPurchaseInvite(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.sendPurchaseInviteUser(args);
  }
  public async discountInvite(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.senddiscountInviteUser(args);
  }

  public async getSearchEmailContent(args: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();
    compProps = await agent.searchEmailProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }
  public async updateRoles(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.getUpdateRolesProps(args);
  }
  public async getSection(args: any) {
    const agent = getAgent();
    return agent.getSectionProps(args);
  }
  public async getCommitteList(args: any) {
    const agent = getAgent();
    return agent.getcommitteListProps(args);
  }

  public async updateMaxInvites(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.getUpdateMaxInvites(args);
  }

  public async recallAllUnusedInvites() {
    const agent = getAgent();

    return agent.recallAllUnusedInvitesProps();
  }

  public async getSingleRecall(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.getSingleRecallProps(args);
  }
  public async discountRecall(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.discountRecall(args);
  }
}
